<template>
  <div class="wrapper">
    <TheHeader />

    <TheAlerts />

    <TheLoading />

    <main class="main" id="main">
      <b-container fluid class="content-wrapper">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.path"></router-view>
        </transition>
      </b-container>
    </main>

    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "@/containers/TheHeader";
import TheFooter from "@/containers/TheFooter";
import TheAlerts from "@/components/TheAlerts";
import TheLoading from "@/components/TheLoading";

export default {
  name: "TheContainer",
  data() {
    return {
      sidebarStatus: true,
    };
  },
  components: {
    TheHeader,
    TheAlerts,
    TheLoading,
    TheFooter,
  },
  methods: {
    toggleSidebar() {
      var sidebar = document.getElementById("sidebar");
      var content = document.getElementById("main");
      var wrapper = document.getElementById("sidebar-wrapper");
      wrapper.classList.toggle("hideEle");
      if (sidebar.style.width === "0%") {
        sidebar.style.width = "15%";
        content.style.width = "85%";
        this.sidebarStatus = true;
      } else {
        sidebar.style.width = "0%";
        content.style.width = "100%";
        this.sidebarStatus = false;
      }
    },
  },
};
</script>
